import {useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {tokenUtility} from "@maya/helper/data-access";
import {baseUrl, baseImageUrl} from "@maya/helper/ui-shared";
import {Navbar, Title} from "@maya/components";
import {Partner, PartnerName} from "@maya/user";
import InfoSection from "./InfoSection";
import SignInSection from "./SignInSection";
import {Testimonial} from "./Testimonial";
import {testimonialData} from "./utils";
import Footer from "./Footer";
import classNames from "classnames";

const ApplyLogin = () => {
  const location = useLocation();
  const params = useParams();
  const queryParams = new URLSearchParams(location.search);
  // e.g. apply/#/loans, apply/#/loan-application, apply/#/tips
  const redirectParam = params["*"] || queryParams.get("redirect") || undefined;
  const from = location.state?.from;
  let partnerName = queryParams.get("utm_source") || queryParams.get("product");

  useEffect(() => {
    if (tokenUtility().getStoredToken()) {
      if (redirectParam) {
        window.location.href = `${baseUrl}/${redirectParam}/#/${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
      } else if (from?.pathname) {
        window.location.href = `${baseUrl}/#${from.pathname}`;
      } else {
        window.location.href = `${baseUrl}/loans/#/`;
      }
    }
  }, []);

  return (
    <div className="bg-white h-screen">
      <Navbar
        isHome
        onHomeIconClick={() => {}}
        className="sticky top-0 z-40 h-18"
      >
        {!!partnerName &&
          Partner?.[partnerName]?.headerLogo &&
          partnerName !== PartnerName.scflipkart && (
            <div>
              <img
                src={Partner[partnerName].headerLogo}
                width={100}
                alt="Partner Logo"
                className="w-[95px] h-[45px] md:w-[125px] md:h-[45px] scale-85 md:scale-100"
              />
            </div>
          )}

        <Title>
          <div
            className={classNames({
              "mr-auto": partnerName === PartnerName.scflipkart,
            })}
          >
            {partnerName === PartnerName.scflipkart ? (
              <img
                src={`${baseImageUrl}/img/ugro-logo.png`}
                alt="Ugro"
                className="translate-x-8 w-[120px] h-[65px] md:w-[135px] md:h-[75px] p-3"
              />
            ) : (
              <img
                src={`${baseImageUrl}/img/logo/logo-row-new.svg`}
                alt="MyShubhLife"
                className="cursor-pointer p-3 scale-95 md:scale-125"
              />
            )}
          </div>
        </Title>
      </Navbar>
      <div className="flex justify-center bg-[whitesmoke] py-12 px-4">
        <div className="flex flex-col w-full max-w-300">
          <div className="flex flex-col-reverse md:flex-row gap-12 w-full max-w-300">
            <InfoSection partnerName={partnerName} />
            <SignInSection
              queryParams={queryParams.toString()}
              redirectParam={redirectParam}
              from={from}
            />
          </div>
          {partnerName === PartnerName.scflipkart && (
            <div className="text-center mt-8">
              <div className="text-md font-semibold text-black mb-1.5">
                Powered by
              </div>
              <img
                src={`${baseImageUrl}/img/logo/logo-row-new.svg`}
                alt="MyShubhLife"
                className="w-[185px] mx-auto mb-1.5 "
              />
              <span className="text-sm text-black">
                MyShubhLife is the digital lending arm of U GRO Capital, India's
                leading MSME lender.
              </span>
            </div>
          )}
        </div>
      </div>

      <Testimonial testimonialData={testimonialData} />
      <Footer />
    </div>
  );
};

export default ApplyLogin;
